import { createContext, useContext } from "react"
import { FirestoreError } from "firebase/firestore"

export type AggregatedObservationsDocuments = {
    visits: number
    feedTypes: number
    triggers: number
}

export type StatisticsContextProps = {
    dataNow: AggregatedObservationsDocuments
    dataPrior: AggregatedObservationsDocuments
    loading: boolean
    error?: FirestoreError
}

export const INIT_AGGREGATED_OBSERVATIONS: AggregatedObservationsDocuments = {
    visits: 0,
    feedTypes: 0,
    triggers: 0,
}

export const StatisticsContext = createContext<StatisticsContextProps>({
    dataNow: INIT_AGGREGATED_OBSERVATIONS,
    dataPrior: INIT_AGGREGATED_OBSERVATIONS,
    loading: true,
    error: undefined,
})

export const useStatistics = () => useContext(StatisticsContext)

export * from "./StatisticsProvider"
